/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `STANDARD` - STANDARD
 *   * `UAP` - UAP
 * ```
 */
export const DatatypeEnum = { STANDARD: 'STANDARD', UAP: 'UAP' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DatatypeEnum = ValuesOf<typeof DatatypeEnum>;

export type DatatypeEnumRequest = DatatypeEnum;
export type DatatypeEnumResponse = DatatypeEnum;
